import _ from 'lodash';
import { preload, goto } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { fetchUserInvitePage } from 'app/api/account-settings-api';
import { updateUserProfile } from 'app/common/api/common-api';
import AcceptInvite from 'app/components/settings/accept-invite';
import { getBasicAccountInfo } from 'app/selectors/user';

const mapStateToProps = (state, ownProps) => ({
  inviterName: ownProps.location.query.inviter,
  initialValues: getBasicAccountInfo(state),
  userSubmitError: _.get(state, 'common.userSubmitError'),
  ..._.get(state, 'accountSettings.userInviteAcceptPage'),
});

const mapDispatchToProps = (dispatch, props) => ({
  // The (valid, pending) invitation token is necessary to authorize the user to
  // update their password
  onSubmit: values => dispatch(updateUserProfile({
    ...values, invitation: props.location.query.invitation,
  })).then(() => dispatch(goto('/setup/terms-and-conditions?entry=new_user'))),
});

const hasInvitePageContent = dispatch =>
  Promise.all([
    dispatch(fetchUserInvitePage()),
  ]);

const AcceptInviteContainer = connect(mapStateToProps, mapDispatchToProps)(preload(
  ({ dispatch, getState }) => hasInvitePageContent(dispatch, getState()))(AcceptInvite),
);

export default AcceptInviteContainer;



// WEBPACK FOOTER //
// ./app/containers/settings/accept-invite.js